import { React, useState } from "react";
import { Link } from "react-router-dom";
import "./Navbar.css";
import {
  FaBars,
  FaChess,
  FaChessKnight,
  FaBookOpen,
  FaQuestion,
} from "react-icons/fa";
import { MdInsertPhoto } from "react-icons/md";
import { IoMdFitness } from "react-icons/io";

const Navbar = () => {
  const [showNavbarLinks, setShowNavbarLinks] = useState(false);

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <div className="navbar-logo-container">
          <Link
            to="/"
            className="navbar-logo"
            onClick={() => setShowNavbarLinks(false)}
          >
            <span className="logo-icon">
              <FaChess />
            </span>
            Chess Tutor
          </Link>
          <button
            className="navbar-btn"
            onClick={() => setShowNavbarLinks(!showNavbarLinks)}
          >
            <FaBars />
          </button>
        </div>
        <ul
          className={`${
            showNavbarLinks ? "navbar-links show-navbar-links" : "navbar-links "
          }`}
          onClick={() => setShowNavbarLinks(false)}
        >
          <li>
            <Link to="/play" className="navbar-link">
              <span className="link-icon">
                <FaChessKnight />
              </span>
              zagraj
            </Link>
          </li>

          <li>
            <Link to="/training" className="navbar-link">
              <span className="link-icon">
                <IoMdFitness />
              </span>
              trening
            </Link>
          </li>
          <li>
            <Link to="/read-from-picture" className="navbar-link">
              <span className="link-icon">
                <MdInsertPhoto />
              </span>
              wczytaj z obrazu
            </Link>
          </li>
          <li>
            <Link to="/dictionary" className="navbar-link">
              <span className="link-icon">
                <FaBookOpen />
              </span>
              słownik
            </Link>
          </li>
          <li>
            <Link to="/rules" className="navbar-link">
              <span className="link-icon">
                <FaQuestion />
              </span>
              Podstawowe zasady
            </Link>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
